import SimilarTitlesView from 'react/views/similarTitles/SimilarTitlesView';
import TitleDetails from 'react/views/titleDetails/TitleDetails';
import createOverviewDetails from '../card/OverviewDetails';
import withOtsEnabled from '../containers/helper/withOtsEnabled';


const TitlesOverviewContainer = createOverviewDetails(SimilarTitlesView, withOtsEnabled(TitleDetails));

export default TitlesOverviewContainer;



// WEBPACK FOOTER //
// ./src/react/views/TitlesOverviewContainer.jsx